export const BASE_ASSET_PATH = "https://el-assets.netlify.app";
